import {API_DRIVER} from "../configs/axios";

export const ModificheService = {
    fetchModificheData: (integrationId, page, size, sortBy, sortOrder, ruleType, msisdn, ruleName, serviceType,
                         userName2, actionType, startDate, endDate) => {
        return API_DRIVER(`/api/rule-audit-logs`, {
            params: {
                integrationId,
                page,
                size,
                sortBy,
                sortOrder,
                ruleType,
                msisdn,
                ruleName,
                serviceType,
                userName2,
                actionType,
                startDate,
                endDate
            }
        })
    },
    fetchModificheDetails: (integrationId, modificheId) => {
        return API_DRIVER.get(`/api/rule-audit-logs/details/${modificheId}`, {
            params: {
                integrationId
            }
        })
    },
    downloadCsv: (selectedRowIds, integrationId, page, size, sortBy, sortOrder, ruleType, msisdn, ruleName, serviceType,
                  userName2, actionType, startDate, endDate, areAllSelected) => {
        return API_DRIVER.post(`/api/rule-audit-logs/download-csv`, selectedRowIds, {
            responseType: 'blob',
            params: {
                integrationId,
                page,
                size,
                sortBy,
                sortOrder,
                ruleType,
                msisdn,
                ruleName,
                serviceType,
                userName2,
                actionType,
                startDate,
                endDate,
                areAllSelected
            }
        })
    },
    downloadCsvForAuditLogId: (eventAuditId, integrationId) => {
        return API_DRIVER.get(`/api/rule-audit-logs/${eventAuditId}/download-csv/integration-id/${integrationId}`,
            {
                responseType: 'blob'
            })
    }
}
